import { useState } from 'react';
import './Header.css'; 
import { Link } from 'react-router-dom';



let Header =(props)=>{
   let spanclickhide=(e)=>{
        document.querySelector(".header_cont").classList.toggle("hideulcont");

        let allmenu = document.querySelectorAll(".header_atag");

        for(let x of allmenu){
            x.addEventListener("click", function(){
                document.querySelector(".topbarhead").innerHTML = x.textContent;
                document.querySelector(".header_cont").classList.remove("hideulcont");
            })
        }   
    }

    
 

    return( 
        <div className='ul_cont_div'>
            <div className='topbar'>
                <span className='topbarhead' style={{color:"white"}}>Home</span>
                <span className='spanx' style={{color:"white"}}><i  onClick={spanclickhide} style={{padding:"", margin:"0"}} className='bx bx-menu'></i></span>
            </div>
            
            <ul className='header_cont'>
                <li className='header_li'><Link className='header_atag' to='./'>HOME</Link></li>
                <li className='header_li'><Link to="./AllDes" className='header_atag'>Degines</Link></li>
                <li className='header_li'><Link to="contactus" className='header_atag'>Contact Us</Link></li>
                <li className='header_li'><Link to="AboutUs" className='header_atag'>About Us</Link></li>  
                <li className='header_li'><Link className='header_atag' to='ChooseYourQualification' >Fill Form</Link></li>
                <li className='header_li'><Link to='LoginPage' className='header_atag'>LogIn/SignUp</Link></li>
                {/* <li className='header_li'><a href='http://localhost/first/API/newloginsystem/loginpage.php' className='header_atag'>LogIn/SignUp</a></li> */}
            </ul>
        </div>
    );
}

export default Header;